import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=51a401ac&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=51a401ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a401ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51a401ac')) {
      api.createRecord('51a401ac', component.options)
    } else {
      api.reload('51a401ac', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=51a401ac&scoped=true&", function () {
      api.rerender('51a401ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Ym7jp5qO0h0j/JS/comp/GuestBox.vue"
export default component.exports